(function () {
  var mobileQuery = window.matchMedia('(max-width: 749px)');

  function initialiseScroller(scroller) {
    if (!scroller || scroller.dataset.aboutSocialInitialised === 'true') return;

    var tiles = Array.prototype.slice.call(
      scroller.querySelectorAll('.about-social__tile')
    );
    if (!tiles.length) return;

    scroller.dataset.aboutSocialInitialised = 'true';
    var animationFrame = null;

    function updateArc() {
      animationFrame = null;
      if (!mobileQuery.matches) return;

      var viewportCenter = scroller.scrollLeft + scroller.clientWidth / 2;
      var closestTile = null;
      var closestDistance = Infinity;

      tiles.forEach(function (tile) {
        var tileCenter = tile.offsetLeft + tile.offsetWidth / 2;
        var signedDistance = tileCenter - viewportCenter;
        var distance = Math.abs(signedDistance);
        var arcPosition = signedDistance / 240;
        var arcDistance = Math.min(Math.abs(arcPosition), 1.35);
        var arcY = 8 + Math.min(88, Math.pow(arcDistance, 1.35) * 68);
        var arcRotation = Math.max(-19, Math.min(19, arcPosition * 14));
        var arcScale = 1 - arcDistance * 0.05;

        tile.style.setProperty('--arc-y', arcY.toFixed(2) + 'px');
        tile.style.setProperty('--arc-rotation', arcRotation.toFixed(2) + 'deg');
        tile.style.setProperty('--arc-scale', arcScale.toFixed(3));
        tile.style.zIndex = String(Math.max(1, Math.round(10 - arcDistance * 6)));

        if (distance < closestDistance) {
          closestDistance = distance;
          closestTile = tile;
        }
      });

      tiles.forEach(function (tile) {
        tile.classList.toggle('is-active', tile === closestTile);
      });
    }

    function requestArcUpdate() {
      if (animationFrame !== null) cancelAnimationFrame(animationFrame);
      animationFrame = requestAnimationFrame(updateArc);
    }

    scroller.addEventListener('scroll', requestArcUpdate, { passive: true });
    window.addEventListener('resize', requestArcUpdate, { passive: true });

    requestAnimationFrame(function () {
      if (mobileQuery.matches && scroller.scrollLeft === 0) {
        scroller.scrollLeft = 240;
      }
      updateArc();
    });
  }

  function initialiseAll(scope) {
    var root = scope && scope.querySelectorAll ? scope : document;
    Array.prototype.forEach.call(
      root.querySelectorAll('[data-social-scroll]'),
      initialiseScroller
    );

    if (root.matches && root.matches('[data-social-scroll]')) {
      initialiseScroller(root);
    }
  }

  if (!window.BonoirAboutSocialSlider) {
    window.BonoirAboutSocialSlider = { initialiseAll: initialiseAll };

    document.addEventListener('DOMContentLoaded', function () {
      initialiseAll(document);
    });
    document.addEventListener('shopify:section:load', function (event) {
      initialiseAll(event.target);
    });
    window.addEventListener('pageshow', function () {
      initialiseAll(document);
    });
  }

  window.BonoirAboutSocialSlider.initialiseAll(document);
})();
